module.exports = __webpack_public_path__ + "static/media/sc_32_i.9c10096b.png";